import React from 'react';
import ChevronUp from 'mdi-react/ChevronUpIcon';
import ChevronDown from 'mdi-react/ChevronDownIcon';

import * as S from './styles';

type OwnProps = {
  expanded: boolean;
  onClick: () => void;
  title?: string;
};

const ExpandButton: React.FC<OwnProps> = ({ expanded, onClick, title }) => (
  <S.ExpandButton
    type="button"
    aria-label={title}
    onClick={onClick}
    expanded={expanded}
    data-test="ExpandButton"
  >
    {expanded ? <ChevronUp /> : <ChevronDown />}
  </S.ExpandButton>
);

export default ExpandButton;
